function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _excluded = ["breakpoints", "centered", "children", "className"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import { fontFamilyBold } from "../../../../themes/fonts.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import { BaseTh } from "../base-table/base-th.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var UnstyledTh = function UnstyledTh(props) {
  var breakpoints = props.breakpoints,
    centered = props.centered,
    children = props.children,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseTh, _extends({}, otherProps, {
    className: classnames(_defineProperty({
      'bf-table__standard-th': true,
      'bf-table__standard-td--breakpoints': !!breakpoints,
      'bf-table__standard-th--centered': centered
    }, "".concat(className), !!className))
  }), children);
};
var blockTh = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n"])));
var getTableTh = function getTableTh(centered) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: table-cell;\n    text-align: ", ";\n  "])), centered ? 'center' : 'left');
};
var getThBreakpoints = function getThBreakpoints(breakpoints, centered) {
  return breakpoints.map(function (breakpoint, index) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      @media (min-width: ", "px) {\n        ", "\n      }\n    "])), breakpoint, index % 2 === 0 ? getTableTh(centered) : blockTh);
  });
};
var StyledTh = styled(UnstyledTh)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 18px;\n  padding: 15px;\n"])), blockTh, function (_ref) {
  var breakpoints = _ref.breakpoints,
    centered = _ref.centered;
  return getThBreakpoints(breakpoints || [], centered);
}, fontFamilyBold);
/**
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/th
 * @param props ThProps
 * @returns FunctionComponent<ThProps>
 */
var Th = function Th(props) {
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(StyledTh, _extends({}, props)));
};
export { Th };